import { appConstants } from "../_constants";
import {
  appHelpers,
  authHeader,
  authFileHeader,
  authBlobHeader,
} from "../_helpers";

export const exchangeRateService = {
  getAllRates,
  addNewRate,
  updateRate,
  uploadRate,
  saveBulkRate,
  approveRate,
  downloadHistory,
  downloadAllRates,
};

function addNewRate(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/CreateAVP`,
      payload,
      authHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
      const errorData = error.response.data || error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE,
      );
    });
}

function getAllRates(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/SearchAVP`,
      payload,
      authHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
      const errorData = error.response.data || error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE,
      );
    });
}

function updateRate(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/UpdateAVP`,
      payload,
      authHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
      const errorData = error.response.data || error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE,
      );
    });
}

function uploadRate(payload) {
  return appHelpers
    .postFormDataRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/UploadRateAVP`,
      payload,
      authFileHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
      const errorData =
        error.response && error.response.data ? error.response.data : error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE,
      );
    });
}

function saveBulkRate(payload) {
  return appHelpers
    .postRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/SaveUploadedRateAVP`,
      payload,
      authHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
      const errorData = error.response.data || error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE,
      );
    });
}

function approveRate(payload) {
  return appHelpers
    .getRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/ApproveAVP?Id=${payload.Id}&approvedBy=${payload.approvedBy}`,
      payload,
      authHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
     const errorData = error.response.data || error;
      return appHelpers.formatPromiseResponse(
        errorData, // Pass the actual error data instead of interpreted message
        appConstants.ERROR_RESPONSE,
      );
    });
}

function downloadHistory(currencyCode) {
  const body = { currencyCode: currencyCode || "" };
  return appHelpers
    .postBinaryRequest(
      `${appConstants.PAS_URL}/api/ExchangeRate/ExportRateHistoryAVP`,
      body,
      authHeader(),
    )
    .then((res) => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch((error) => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE,
      );
    });
}

function downloadAllRates(payload, downloadType) {
  const body = Object.assign({}, payload || {}, { downloadType });
  return appHelpers
    .postBinaryRequest(`${appConstants.PAS_URL}/api/ExchangeRate/ExportRateAVP`, body, authHeader())
    .then(res => {
      return appHelpers.formatPromiseResponse(res);
    })
    .catch(error => {
      let errorMessage = appHelpers.interpretErrorResponse(error);
      return appHelpers.formatPromiseResponse(
        errorMessage,
        appConstants.ERROR_RESPONSE
      );
    });
}

// function downloadAllRates(payload, downloadType) {
//     return appHelpers
//       .getBinaryRequest(
//         `${appConstants.PAS_URL}/api/manifest/download?manifestid=${manifestId}`, 
//         authHeader()
//       )
//       .then(res => {
//         return appHelpers.formatPromiseResponse(res);
//       })
//       .catch(error => {
//         let errorMessage = appHelpers.interpretErrorResponse(error);
//         return appHelpers.formatPromiseResponse(
//           errorMessage,
//           appConstants.ERROR_RESPONSE
//         );
//       });
//   }


// WEBPACK FOOTER //
// ./src/_services/exchange-rate.service.js